export default () => {
  return [
    {
      name: "Permanent",
      key: "PERMANENT",
    },
    {
      name: "Term",
      key: "TERM",
    },
  ];
};
